import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";

export default function NotFound({ ...props }) {
  let history = useHistory();

  const [open, setOpen] = useState(true);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    history.push("/home");
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        disableEscapeKeyDown
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle data-test={"not-found-title"} id="alert-dialog-title">
          Page not available - 404
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            data-test={"not-found-text"}
            id="alert-dialog-description"
          >
            The page you have tried to access does not exist.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            data-test={"not-found-home-btn"}
            onClick={() => {
              history.push("/home");
            }}
          >
            Go back to homepage
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
